import React from 'react';
import { Form, Button, Icon, Message, Divider } from 'semantic-ui-react'
import _find from 'lodash/find';

const CambClave2 = ({styles, usuActivo, handleSubmit, handleChange, args, errors, handleClickRegr}) => {
  // console.log(usuActivo)
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Cambiar clave de acceso
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>{
          handleSubmit(ev, args, usuActivo[0])}
          // handleClickRegr(ev)}
        }>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Clave de acceso ACTUAL</label>
                  <input style={styles.input} autoComplete="off" name="claveDeAccesoAct" id="claveDeAccesoAct" onChange={handleChange} type='password' placeholder='Clave de acceso actual' icon={!errors.length?null: _find(errors, {path:'Clave de acceso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>NUEVA clave de acceso</label>
                  <input style={styles.input} autoComplete="off" name="claveDeAccesoNva1" id="claveDeAccesoNva1" onChange={handleChange} type='password' placeholder='Clave de acceso nueva' icon={!errors.length?null: _find(errors, {path:'Clave de acceso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Repetir NUEVA clave de acceso</label>
                  <input style={styles.input} autoComplete="off" name="claveDeAccesoNva2" id="claveDeAccesoNva2" onChange={handleChange} type='password' placeholder='Clave de acceso nueva' icon={!errors.length?null: _find(errors, {path:'Clave de acceso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>

                <Divider inverted />

                <Button style={styles.confirmar} type='submit' fluid>
                    CAMBIAR CLAVE DE ACCESO
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default CambClave2
